const TitleButton = ({ title }: { title: string }) => {
    return (
        <div className="rounded-[10px] bg-my-gray bg-opacity-10 border border-my-gray border-opacity-60 w-fit p-[10px] text-my-black leading-[17px]">
            {title}
        </div>
    );
};

export default TitleButton;
